import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0692a0e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row pb-1 pt-1"
}
const _hoisted_2 = { class: "flex xs4" }
const _hoisted_3 = { class: "flex xs2" }
const _hoisted_4 = { class: "flex xs2 offset--xs1" }
const _hoisted_5 = { class: "gutter--sm" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_8 = {
  class: "flex sm12",
  style: {"text-align":"center"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Welcome to Crypto Notifi. The first step is to setup one or more channels where you will recieve alerts. ", -1))
const _hoisted_10 = { class: "pt-3" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" You can access ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" My Channels ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" to configure channels to receive alerts and then return here to Subscribe! ")
const _hoisted_14 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Welcome to Crypto Notifi! You have not created any subscriptions yet, but once you do they will appear here for easy maintenance and review. ", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" To get started, click the Add Button to create your first subscription! ")

import useDebouncedRef from "@/composables/useDebouncedRef";
import SubscriptionCard from "@/components/Subscription.vue";
import ProtocolSelector from "@/components/ProtocolSelector.vue";
import GroupPicker from "@/components/GroupPicker.vue";
import Moralis from "moralis";
import { computed, onMounted, ref } from "vue";
import { Subscription } from "@/models/Subscription";
import { Protocol } from "@/models/Protocol";
import { useSubscriptionsStore } from "@/store/pinia_subscriptions";
import { useUserChannelsStore } from "@/store/pinia_userChannel";
import { useRouter } from "vue-router";
import { Group } from "@/models/Group";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  props: { showAdd: Boolean },
  emits: ["showChannels"],
  setup(__props, { emit }) {

const props = __props

const router = useRouter();

const search = useDebouncedRef("");
const searchProtocols = ref<Protocol[]>([]);
const searchGroup = ref<Group>();
const subscriptionStore = useSubscriptionsStore();
const {
  rawCount,
  subscriptions: rawSubscriptions,
  loading,
} = storeToRefs(subscriptionStore);

// eslint-disable-next-line no-undef

// eslint-disable-next-line no-undef

const showGroups = ref(false);

const refresh = () => {
  subscriptionStore.fetchSubscriptions();
};

onMounted(() => {
  subscriptionStore.fetchSubscriptions();
});

const subscriptions = computed((): Subscription[] => {
  let subs = rawSubscriptions.value;
  if (search.value) {
    subs = subs.filter((s) => {
      return s.name.toLowerCase().includes(search.value.toLowerCase());
    });
  }
  if (searchProtocols.value.length > 0) {
    const prots = searchProtocols.value.map((e) => e.id);
    subs = subs.filter((s) => {
      const p = s.protocol;
      if (!p) {
        return false;
      }
      return prots.includes(p.id);
    });
  }
  if (searchGroup.value) {
    subs = subs.filter((s) => {
      const gr = s.get("Group");
      return gr && gr.id == searchGroup.value?.id;
    });
  }
  return subs;
});
const showNoChannels = computed((): boolean => {
  const userChannelsStore = useUserChannelsStore();
  return !loading.value && userChannelsStore.userChannels.length == 0;
});
const showNoSubscriptions = computed((): boolean => {
  return (
    !showNoChannels.value &&
    rawCount.value == 0 &&
    rawSubscriptions.value.length == 0 &&
    !loading.value
  );
});

const addSubscription = (): void => {
  router.push({ name: "SubscriptionNew" });
};
const showChannels = (): void => {
  router.push({ name: "My Channels" });
};
const setSearchProtocols = (prots: Protocol[]): void => {
  searchProtocols.value = prots;
};

const allowAdd = computed((): boolean => {
  return true;
});

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(showNoSubscriptions) && !_unref(showNoChannels))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_va_input, {
            class: "flex xs3",
            label: "Search Names",
            modelValue: _unref(search),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ProtocolSelector, {
              simpleList: true,
              simpleMulti: true,
              onSelection: setSearchProtocols
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(GroupPicker, {
              editOnly: true,
              modelValue: searchGroup.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchGroup).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_va_button, {
              icon: "refresh",
              color: "secondary",
              onClick: refresh
            }),
            _createVNode(_component_va_popover, { message: "Add a new Subscription" }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  onClick: _withModifiers(addSubscription, ["prevent"]),
                  "icon-right": "add",
                  size: "medium",
                  class: "ml-4",
                  color: "success",
                  disabled: !_unref(allowAdd)
                }, null, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_va_inner_loading, {
        loading: _unref(loading),
        size: 60
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subscriptions), (subscription) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex xs12 sm6 md6 lg4 xl3 pb-3",
                key: subscription.id
              }, [
                _createVNode(SubscriptionCard, { subscription: subscription }, null, 8, ["subscription"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["loading"]),
      (_unref(showNoChannels))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h2", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_va_button, {
                  color: "primary",
                  onClick: _withModifiers(showChannels, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _hoisted_13
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(showNoSubscriptions))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("h2", null, [
              _hoisted_16,
              _createVNode(_component_va_button, {
                onClick: _withModifiers(addSubscription, ["prevent"]),
                "icon-right": "add",
                size: "large",
                color: "success",
                disabled: !_unref(allowAdd)
              }, null, 8, ["onClick", "disabled"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})